<template>
    <rkm-modal
        ref="modal"
        title="Observação"
    >
        <rkm-form
            ref="Form"
        >
            <rkm-form-textarea
                label="Observação"
                v-model="model.observacao"
                disabled
            />
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Fechar
            </rkm-button>
        </template>

    </rkm-modal>
</template>
<script>

// Mixin.
import { repository } from '@/mixins'

export default {
    data: () => ({
        model: {
            id: null,
            observacao: null,
        },
    }),
    methods: {

        open(index) {

            this.model.id = index
            this.model.observacao = this.data[index].observacao
            this.$refs.modal.show()
        },
    },
    mixins: [ repository ],
    props: {
        data: { type: [Array, Object], required: true },
    },
}
</script>